import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { CONTAINERS_LIST } from 'shared/enums';
import { withPayloadType } from 'utils/payloadType';
import { MAIN_NAVIGATION_ACTIONS } from './constants';

import { resetEpsModeAction } from '../epsNavigationMode';
import { resetMailingRuleModeAction } from '../mailingRuleModeNavigation';
import { resetRemunerationModeAction } from '../remunerationModeNavigation/actions';
import {
  resetSettingsAction,
  setSettingsNavigationAction,
} from '../settingsNavigation';
import { listOperationsAction, listResourcesAction } from '../permissionList';
import { listPoliciesAction } from '../policyList';
import { listIdentitiesAction } from '../identityList';

import {
  initialState as initialStateMailing,
  resetMailingModeAction,
} from 'modules/mailingNavigationMode';
import { tabsEntries as tabsEntriesMailing } from 'containers/Mailing/helpers';

import { initialState as initialStateSettings } from 'modules/settingsNavigation';
import { tabsEntries as tabsEntriesSettings } from 'containers/Settings/helpers';

import { store } from 'store';
import { setFirstSubContainerAvailable } from 'utils/navigationContainers';
import { setMailingModeAction } from 'modules/mailingNavigationMode';
import { resetRemunerationAction } from 'modules/remunerationNavigation';
import { resetStrategyRegisterAction } from 'modules/strategy';

const setSelectedContainerActionFulfilled = createAction(
  MAIN_NAVIGATION_ACTIONS.SET_CONTAINER_FULFILLED,
  withPayloadType<CONTAINERS_LIST>(),
);

const setSelectedContainerAction = createAsyncThunk(
  MAIN_NAVIGATION_ACTIONS.SET_CONTAINER_REQUEST,
  (container: CONTAINERS_LIST) => {
    if (container !== CONTAINERS_LIST.NO_CAR_OI_ACCESS) {
      store.dispatch(resetEpsModeAction());
      store.dispatch(resetMailingRuleModeAction());
      store.dispatch(resetRemunerationModeAction());
      store.dispatch(resetSettingsAction());
      store.dispatch(resetMailingModeAction());
      store.dispatch(resetRemunerationAction());
      store.dispatch(resetStrategyRegisterAction());
      store.dispatch(setSelectedContainerActionFulfilled(container));

      if (container === CONTAINERS_LIST.MAILING) {
        const { mode } = store.getState().mailingNavigationMode;
        setFirstSubContainerAvailable({
          tabsEntries: tabsEntriesMailing,
          currentTab: mode,
          defaultTab: initialStateMailing.mode,
          setNavigationAction: setMailingModeAction,
        });
      }

      if (container === CONTAINERS_LIST.SETTINGS) {
        store.dispatch(listResourcesAction());
        store.dispatch(listOperationsAction());
        store.dispatch(listPoliciesAction({ limit: 9999 }));
        store.dispatch(listIdentitiesAction({ limit: 9999 }));

        const { mode } = store.getState().settingsNavigation;
        setFirstSubContainerAvailable({
          tabsEntries: tabsEntriesSettings,
          currentTab: mode,
          defaultTab: initialStateSettings.mode,
          setNavigationAction: setSettingsNavigationAction,
        });
      }
    } else {
      store.dispatch(setSelectedContainerActionFulfilled(container));
    }
  },
);

export { setSelectedContainerAction, setSelectedContainerActionFulfilled };

export type ActionTypes = ReturnType<
  typeof setSelectedContainerActionFulfilled
>;
